module.exports = __webpack_public_path__ + "static/media/meeting-placeholder.7b2bcddc.png";